import { useModals } from 'almanac-ui/Modal'
import { useVirtualMarketerPlan } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/hooks/useVirtualMarketerPlan'
import { VirtualMarketerPlansModal } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/VirtualMarketerPlansModal/VirtualMarketerPlansModal'
import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { AutopilotPlansModal } from 'components/Settings/Workspace/AutopilotPlans/AutopilotPlansModal'
import { useCampaignsFeatureFlag } from './useCampaignsFeatureFlag'
import { useIsActiveOrCanceledPioneerPlan } from './useIsActiveOrCanceledPioneerPlan'

export interface OpenAutopilotUpgradeOptions {
  newStack?: boolean
}

export const useOpenAutopilotUpgrade = (): ((options?: OpenAutopilotUpgradeOptions) => void) => {
  const isCampaignsEnabled = useCampaignsFeatureFlag()
  const { openModal, closeStack, closeAllModals } = useModals()
  const { data: virtualMarketerPlan } = useVirtualMarketerPlan()
  const workspace = useCurrentWorkspace()
  const tierUsageStore = useRootStore().tierUsageStore
  const isActiveOrCanceledPioneerPlan = useIsActiveOrCanceledPioneerPlan()

  return (options?: OpenAutopilotUpgradeOptions) => {
    const modalOptions = options?.newStack ? { newStack: true } : undefined

    if (isCampaignsEnabled || isActiveOrCanceledPioneerPlan) {
      openModal(AutopilotPlansModal, {}, modalOptions)
      return
    }

    if (!virtualMarketerPlan) return

    openModal(
      VirtualMarketerPlansModal,
      {
        plan: virtualMarketerPlan,
        onSuccess: () => {
          if (workspace) tierUsageStore.fetch(workspace.id)

          if (options?.newStack) {
            closeStack()
          } else {
            closeAllModals()
          }
        },
      },
      modalOptions,
    )
  }
}

export const useOpenAutopilotUpgradeIfNeeded = (): ((onNotFreemium?: (...args: any[]) => any) => void) => {
  const openAutopilotUpgrade = useOpenAutopilotUpgrade()
  const workspace = useCurrentWorkspace()

  return (onNotFreemium?: (...args: any[]) => any) => {
    if (workspace?.is_ap_freemium) {
      openAutopilotUpgrade()
    } else {
      onNotFreemium?.()
    }
  }
}
